import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { PluginSeverity, PolicyLevel } from '@uigy/generated/graphql';
import { SeverityPillComponent } from '@uigy/shared/components/ui-severity-pill/severity-pill.component';


@Component({
    selector: 'app-severity-cell-renderer',
    imports: [
        SeverityPillComponent
    ],
    templateUrl: './severity-cell-renderer.component.html',
    styleUrl: './severity-cell-renderer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeverityCellRendererComponent implements ICellRendererAngularComp {
  public score?: PluginSeverity | PolicyLevel;

  public agInit(params: ICellRendererParams): void {
    this.score = params.value;
  }

  public refresh(): boolean {
    return false;
  }
}
